import { useCallback } from 'react';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';

export type IneligibilityReasons =
	| 'NEW_SITE_LESS_THAN_7_DAYS_OLD'
	| 'ALREADY_HAVE_ACCESS'
	| 'NOT_ELIGIBLE_FOR_REQUEST_ACCESS'
	| 'NO_COLLABORATORS_FOUND'
	| 'COLLABORATORS_HAVE_NO_ACCESS'
	| 'ELIGIBLE'
	| 'NO_CONFLUENCE_LICENSE'
	| 'YOUR_WORK_ROUTE';

export const useEligibilityChecked = () => {
	const flagKey = 'cross-join-third-party-nudges';
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return useCallback(
		(ineligibilityReason: IneligibilityReasons) => {
			try {
				fireTrackAnalytics(createAnalyticsEvent({}), 'eligibility checked', {
					flagKey,
					ineligibilityReason,
					source: 'jira-cross-join-third-party-nudges',
				});
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				fireErrorAnalytics({
					meta: {
						id: 'useFeatureExposed',
						packageName: 'jiraCrossJoinThirdPartyNudges',
					},
					error,
					sendToPrivacyUnsafeSplunk: true,
				});
			}
		},
		[createAnalyticsEvent, flagKey],
	);
};
